var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphoneIconSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 58.3333H66.6666V35.4167H33.3333V58.3333ZM52.0833 62.5V66.6667H60.4166V70.8333H39.5833V66.6667H47.9166V62.5H31.2333C30.9597 62.4984 30.6891 62.4428 30.4371 62.3364C30.185 62.23 29.9565 62.0749 29.7645 61.88C29.5725 61.6851 29.4209 61.4542 29.3183 61.2006C29.2157 60.947 29.1641 60.6757 29.1666 60.4021V33.3479C29.1666 32.1896 30.1145 31.25 31.2333 31.25H68.7666C69.9083 31.25 70.8333 32.1854 70.8333 33.3479V60.4021C70.8333 61.5604 69.8853 62.5 68.7666 62.5H52.0833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIconSix);
export default __webpack_public_path__ + "static/media/iphone-icon-six.d328cca81599eed665c075a08102d35d.svg";
export { ForwardRef as ReactComponent };